import { useContext } from 'react';

import { DynamicAssessmentContext } from '../contexts/DynamicAssessmentContext';
import type { DynamicAssessmentApiClient } from '../types/dynamicAssessmentApiClient';

/**
 * The injected HTTP client. Throws rather than falling back to a default instance:
 * a missing provider is a wiring bug, and failing at mount beats every network call
 * silently hitting the wrong base URL.
 */
export function useDynamicAssessmentApiClient(): DynamicAssessmentApiClient {
  const value = useContext(DynamicAssessmentContext);
  if (!value) {
    throw new Error(
      'useDynamicAssessmentApiClient must be used within a DynamicAssessmentProvider'
    );
  }
  return value.apiClient;
}
